import React from "react";
import { useStores } from "store";

export enum DeviceSubscriptionTopic {
    CONNECTIVITY = 'device.connectivity',
    DEVICE_INFO = 'device.info',
}

interface SocketSubscriptionOptions<TSubscribe, TEvent> {
    topic: string;
    buildSubscribePayload: () => TSubscribe;
    buildUnsubscribePayload?: () => unknown;
    onEvent: (event: TEvent) => void;
}

export function useSocketSubscription<TSubscribe, TEvent>(options: SocketSubscriptionOptions<TSubscribe, TEvent>) {
    const {
        topic,
        buildSubscribePayload,
        buildUnsubscribePayload,
        onEvent,
    } = options;

    const { socketClientStore } = useStores();
    const socketClient = socketClientStore.socketClient;

    React.useEffect(() => {
        if (!socketClient) return;

        let mounted = true;

        const subscribe = () => {
            socketClient.emitMessage(`${topic}.subscribe`, buildSubscribePayload());
        };

        const unsubscribe = () => {
            socketClient.emitMessage(`${topic}.unsubscribe`, buildUnsubscribePayload?.());
        };

        subscribe();

        socketClient.reconnect(() => {
            if (!mounted) return;
            subscribe();
        });

        socketClient.listenOn<TEvent>(`${topic}.changed`, (event) => {
            if (!mounted) return;
            onEvent(event);
        });

        return () => {
            mounted = false;
            unsubscribe();
        };
    }, [socketClient, topic]);
}
